import { BannerStyled } from './styles';

export const NothingToReviewBanner = (): JSX.Element => {
  return <BannerStyled>There are no assessments to review yet. Once there are, you will be able to review them.</BannerStyled>;
};
